/* ============
 * Account Index Page
 * ============
 *
 * Page where the user can view the account information
 */
import api from './../../services/api';
import authService from './../../services/auth';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import Vue from 'vue';
export default {
  data() {
    return {
      user: {
        eresasistente: false,
        nombre: '',
        apellido: '',
        email: '',
        password: '',
        repeat_password: '',
        tokenredsocial: ''
      },
      urlSite:'',
      linkTerms:'',
      linkPolicies:'',
      message:'',
    }
	},
  created() {
    this.user.nombre = localStorage.getItem('userNombre')!=''? localStorage.getItem('userNombre'):'';
    this.user.apellido = localStorage.getItem('userApellido')!=''? localStorage.getItem('userApellido'):'';
    this.urlSite = localStorage.getItem('codigoPais')=='CL'? 'https://www.mesa247.cl/':'https://www.mesa247.pe/';
    this.linkTerms = localStorage.getItem('lang') =='es'? this.urlSite+'terminos_condiciones':this.urlSite+'en/terms_and_conditions';
    this.linkPolicies = localStorage.getItem('codigoPais')=='es'? this.urlSite+'politicas_restaurante':this.urlSite+'en/privacy_terms';
    localStorage.removeItem('userNombre');
    localStorage.removeItem('userApellido');
  },
  methods: {
		back() {
      Vue.router.go(-1);
    },
    async doSignup(data) {
      (data.nombre=='' || data.apellido=='' || data.email=='' || data.password=='' || data.repeat_password=='')? this.message = this.$t('inputs.fill_your_data'):'';
      (data.password!=data.repeat_password && this.message=='')? this.message = this.$t('inputs.password_not_match'):'';
      if(this.message!=''){
        Toast({
          message: this.message,
          position: 'bottom',
          duration: 5000,
        });
      }else{
        data.webmovil = 1;
        // eslint-disable-next-line
        ga('send', 'event', 'Button', 'click', 'Login: Create account');
        await authService.signup(data);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/signup/index.js